export const translations = {
  en: {
    // Navigation
    expenseTracker: "Expense Tracker",
    home: "Home",
    settings: "Settings",
    history: "History",
    dashboard: "Dashboard",
    signOut: "Sign out",
    welcome: "Welcome",
    menu: "Menu",

    // Form Labels
    expenses: "Expenses",
    income: "Income",
    date: "Date",
    note: "Note",
    submit: "Save",
    submitting: "Saving...",
    addExpense: "Add Expense",
    addIncome: "Add Income",
    pleaseEnterCash: "Please enter amount",
    quickCash: "Quick Cash",
    quickNotes: "Quick Notes",
    source: "Source",
    selectSource: "Select Source",

    // Income Sources
    salary: "Salary",
    freelance: "Freelance",
    investments: "Investments",
    business: "Business",
    bonus: "Bonus",
    other: "Other",
    incomeHistory: "Income History",

    // Dashboard
    expenseDashboard: "Expense Dashboard",
    totalExpenses: "Total Expenses",
    thisMonthExpenses: "This Month's Expenses",
    monthlyTarget: "Monthly Budget",
    overBudget: "Over budget!",
    ofTarget: "of target",
    addNewExpense: "Add New Expense",
    remainingAmount: "Remaining",
    overAmount: "Over by",
    monthlyIncome: "This Month's Income",
    netBalance: "Net Balance",
    warningExpensesHigh: "Warning: Expenses are over 80% of income!",
    totalIncome: "Total Income",
    remaining: "Remaining",
    ofTotalIncome: "of total income",
    used: "Used",
    
    // Visualization
    monthlyExpenses: "Monthly Expenses",
    expensesByCategory: "Expenses by Category",
    categoryTrends: "Category Trends Over Time",
    monthlyIncomeVis: "Monthly Income",
    noIncomeData: "No income data available to visualize",
    noExpenseData: "No expense data available to visualize",

    // Settings
    languageSettings: "Language Settings",
    selectLanguage: "Select Language",
    currentTarget: "Current Target",
    enterNewTarget: "Enter new target",
    update: "Update",
    quickCashValues: "Quick Cash Values",
    enterNewValue: "Enter new value",
    add: "Add",
    enterNewNote: "Enter new note",

    // Savings
    savings: "Savings",
    savingsGoal: "Monthly Savings Goal",
    enterSavingsGoal: "Enter savings goal",
    savingsProgress: "Progress towards goal",
    currentSavings: "Current Savings",

    // Quick Notes
    groceries: "Groceries",
    transport: "Transport",
    entertainment: "Entertainment",
    utilities: "Utilities",
    rent: "Rent",
    shopping: "Shopping",

    // History
    expenseHistory: "Expense History",
    day: "Day",
    amount: "Amount",
    total: "Total",
    deleteEntry: "Delete entry",
    failedToRemove: "Failed to remove entry. Please try again.",
  },
  ar: {
    // Navigation
    expenseTracker: "متتبع المصاريف",
    home: "الرئيسية",
    settings: "الإعدادات",
    history: "السجل",
    dashboard: "لوحة المعلومات",
    signOut: "تسجيل الخروج",
    welcome: "مرحباً",
    menu: "القائمة",

    // Form Labels
    expenses: "المصاريف",
    income: "الدخل",
    date: "التاريخ",
    note: "ملاحظة",
    submit: "حفظ",
    submitting: "جاري الإرسال...",
    addExpense: "إضافة مصروف",
    addIncome: "إضافة دخل",
    pleaseEnterCash: "الرجاء إدخال المبلغ",
    quickCash: "المبالغ السريعة",
    quickNotes: "الملاحظات السريعة",
    source: "المصدر",
    selectSource: "اختر المصدر",

    // Income Sources
    salary: "راتب",
    freelance: "عمل حر",
    investments: "استثمارات",
    business: "تجارة",
    bonus: "مكافأة",
    other: "أخرى",
    incomeHistory: "سجل الدخل",

    // Dashboard
    expenseDashboard: "لوحة المصاريف",
    totalExpenses: "إجمالي المصاريف",
    thisMonthExpenses: "مصاريف هذا الشهر",
    monthlyTarget: "الحد الشهري",
    overBudget: "تجاوزت الميزانية!",
    ofTarget: "من الهدف",
    addNewExpense: "إضافة مصروف جديد",
    remainingAmount: "المتبقي",
    overAmount: "تجاوزت بمقدار",
    monthlyIncome: "دخل هذا الشهر",
    netBalance: "الرصيد الصافي",
    warningExpensesHigh: "تحذير: المصاريف تجاوزت 80% من الدخل!",
    totalIncome: "إجمالي الدخل",
    remaining: "المتبقي",
    ofTotalIncome: "من إجمالي الدخل",
    used: "مستخدم",

    // Visualization
    monthlyExpenses: "المصاريف الشهرية",
    expensesByCategory: "المصاريف حسب الفئة",
    categoryTrends: "اتجاهات الفئات عبر الزمن",
    monthlyIncomeVis: "الدخل الشهري",
    noIncomeData: "لا توجد بيانات دخل متاحة للعرض",
    noExpenseData: "لا توجد بيانات مصاريف متاحة للعرض",

    // Settings
    languageSettings: "إعدادات اللغة",
    selectLanguage: "اختر اللغة",
    currentTarget: "الهدف الحالي",
    enterNewTarget: "أدخل هدفاً جديداً",
    update: "تحديث",
    quickCashValues: "قيم النقد السريع",
    enterNewValue: "أدخل قيمة جديدة",
    add: "إضافة",
    enterNewNote: "أدخل ملاحظة جديدة",

    // Savings
    savings: "المدخرات",
    savingsGoal: "هدف الادخار الشهري",
    enterSavingsGoal: "أدخل هدف الادخار",
    savingsProgress: "التقدم نحو الهدف",
    currentSavings: "المدخرات الحالية",

    // Quick Notes
    groceries: "البقالة",
    transport: "المواصلات",
    entertainment: "الترفيه",
    utilities: "المرافق",
    rent: "الإيجار",
    shopping: "التسوق",

    // History
    expenseHistory: "سجل المصاريف",
    day: "اليوم",
    amount: "المبلغ",
    total: "المجموع",
    deleteEntry: "حذف السجل",
    failedToRemove: "فشل في حذف السجل. يرجى المحاولة مرة أخرى.",
  },
};
